import { useState } from 'react';
import FiltrosFactuBox from '../components/factubox/FiltrosFactuBox';
import TablaFacturas from '../components/factubox/TablaFacturas';
import './FactuBox.css';

/**
 * PosBox - Listado de facturas con opción de ver/descargar PDF
 */
function FactuBox() {
  const [filtros, setFiltros] = useState({
    fecha_inicio: getFechaHoy(),
    fecha_fin: getFechaHoy(),
    busqueda: '',
  });

  return (
    <div className="factubox-page">
      <div className="factubox-page-header">
        <h1>PosBox</h1>
        <p>Historial de facturas</p>
      </div>

      <div className="factubox-content">
        <FiltrosFactuBox
          filtros={filtros}
          onChange={setFiltros}
        />
        <TablaFacturas filtros={filtros} />
      </div>
    </div>
  );
}

function getFechaHoy() {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'America/Bogota' });
}

export default FactuBox;
